import { render, staticRenderFns } from "./PutinForm.vue?vue&type=template&id=2ef34233&scoped=true&"
import script from "./PutinForm.vue?vue&type=script&lang=js&"
export * from "./PutinForm.vue?vue&type=script&lang=js&"
import style0 from "./PutinForm.vue?vue&type=style&index=0&id=2ef34233&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef34233",
  null
  
)

export default component.exports